import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import {
  ImageAssetParameters,
  ImageDescriptionContent,
  ImageDescriptionContentSource
} from "../types";

export function getModuleAssets(source: ImageDescriptionContent): Array<Image> {
  return [source.image];
}

export function transformModuleAssets(
  source: ImageDescriptionContentSource,
  assetParams: ImageAssetParameters
): ImageDescriptionContent {
  return {
    ...source,
    image: getCdnImageDetails(source.imageURL, assetParams.default)
  };
}
